export const loginRegex = {
    LOGIN_RE: /(def%26service%3D){1}(.*\\.com)?.*/
};
